import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BrowseFile } from "components/BrowseFile/BrowseFile";
import { Button } from "components/Button/Button";
import { useEffect, useState } from "react";
import { importFiles, importFilesPackage } from "../api";

interface Props {
    showForm?: () => any;
    reload?: () => any;
    ISPackage?:any;
}

export const ImportForm = ({ showForm, reload  ,ISPackage=false}: Props) => {
    const [resetForm, setResetForm] = useState(false);
    const [selectedFiles, setSelectedFiles] = useState<any>([]);

    const handleSelectedFiles = (e: any) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedFiles([...selectedFiles, ...Array.from(e.target.files)]);
        }
    };

    const removeFile = (index: number) => {
        setSelectedFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    async function sendDataToServer(event) {
        event.preventDefault();
        try {
            const data = new FormData();
            selectedFiles.forEach((file) => data.append("file", file));
            if(ISPackage){
                await importFilesPackage(data);
          }else  await importFiles(data);
          reload && reload();
            setSelectedFiles([]);
        } catch (error) {
            console.error("Error uploading files", error);
        }
    }

    useEffect(() => {
        if (resetForm) {
            setResetForm(false);
            setSelectedFiles([]);
        }
    }, [resetForm]);

    return (
        <div className="col-lg-12 mb-1">
            <div className="card">
                <div className="card-body">
                    <form className="row d-flex flex-row" onSubmit={sendDataToServer}>
                        <div className="col-lg-4 mt-3">
                          <BrowseFile multiple={true} onChange={handleSelectedFiles} />
                            
    
                        </div>
                        <div className="col-lg-12 mt-1">
                            {selectedFiles.length > 0 && (
                                <>
                                {selectedFiles.map((item, index) => (
                                    item?.file?.type?.includes("image") ?
                                    <div className="col-5 border border-1 rounded-3" style={{display:"flex",position:'relative'}}>
                                         <div style={{ width: "16px", height: "16px", position: "absolute", left: "2px", top: "2px", }}>
                                            <FontAwesomeIcon onClick={() => { removeFile(index) }} icon={['fas', 'times']} className="text-primary" style={{ cursor: 'pointer', height: "16px", width: "15px" }} />
                                        </div>
                                    <div className={`FileOption  `} style={{ height: "200px", width: "200px" }}>
                                        <img src={item.Tu} style={{ height: "200px", width: "200px" }} onClick={() => {}} />
                                    </div>
                                    {item.name} 
                                    </div>
                                        
                                    :
                                    <div className="col-5 border border-1 rounded-3" style={{display:"flex",position:'relative'}}>
                                         <div  style={{ width: "16px", height: "16px", position: "absolute", left: "2px", top: "2px", }}>
                                            <FontAwesomeIcon onClick={() => { removeFile(index) }} icon={['fas', 'times']} className="text-primary" style={{ cursor: 'pointer', height: "16px", width: "15px" }} />
                                        </div>
                                    <object className={`FileOption  `}   >
                                        <FontAwesomeIcon icon={['fas', 'file']} onClick={() => {  }} color='grey' style={{ cursor: 'pointer', height: "40px" }} />
                                    </object>
                                    <div className="mt-3 showDots">

                                        {item.name} 
                                    </div>
                                    </div>
                                ))}
                                </>
                            )}
                        </div>
                        <div className="col-lg-12 mt-1 btns_form">
                            <Button value="Confirm" btnType="submit" />
                            <Button
                                btnType="cancel"
                                value="Cancel"
                                onClick={() => {
                                    setResetForm(true);
                                    showForm && showForm();
                                }}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
